export const EventCategories = {
  SINGLE_JOB_MANAGEMENT: 'Single Job Management',
  PROJECT_QUESTION: 'Project Question',
  FB_CONNECT: 'FB Connect',
  USER_SIGN_IN: 'User Sign In'
};

export const EventActions = {
  ACTION_BUSINESS: 'Action Business',
  CONTACT_SUPPORT: 'Contact Support',
  CHANGE_JOB_STATUS: 'Change Job Status',
  VIEW_JOB_DETAILS: 'View Job Details',
  SELECT_WAITLISTED_BUSINESS: 'Select Waitlisted Business',
  POPUP_DISPLAYED_NEW_DESIGN_AND_HAS_CATEGORIES: 'Popup displayed - new design and has Categories',
  REPORT_CONNECTIONS: 'Report Connections',
  CLICKED_LOGIN_BUTTON: 'Clicked Login Button',
  FACEBOOK_CONNECT: 'Facebook Connect',
  CLICKED_CREATE_PASSWORD: 'clicked create password'
};

export const EventLabels = {
  PRESS_BUSINESS_CARD: 'Press Business Card',
  PRESS_BUSINESS_DETAILS: 'Press Business Details',
  PRESS_MESSAGE_BUTTON: 'Press Message Button',
  PRESS_HIRE_BUTTON: 'Press Hire Button',
  PRESS_MORE_BUTTON: 'Press More Button',
  PRESS_MAKE_A_PAYMENT_BUTTON: 'Press Make a Payment Button',
  PRESS_REQUEST_RECEIPT_BUTTON: 'Press Request Receipt Button',
  PRESS_LEAVE_FEEDBACK_BUTTON: 'Press Leave Feedback Button',
  PRESS_VIEW_PROFILE: 'Press View Profile',
  PRESS_CONTACT_SUPPORT_BUTTON: 'Press Contact Support Button',
  CLICK_CLOSE_JOB: 'Click Close Job',
  CLICK_VIEW_DETAILS_BUTTON: 'Click View Details Button',
  PRESS_CONNECT_BUTTON: 'Press Connect Button',
  AFTER_JOBS_PAGE: 'After Jobs Page',
  SUCCESS_PAGE_NEW_USER: 'success page - new user',
  SUCCESS_PAGE_REPEAT_USER: 'success page - repeat user',
  FB_ERROR_NOTIFICATION_DISPLAYED: 'FB - error notification displayed',
  CLICK_BUSINESS_THUMBNAIL: 'Click Business Thumbnail',
  CLICK_PHONE_NUMBER: 'Click Phone Number'
};
